export enum QuotationType {
  Budget = 1,
  PrognosisSpring = 2,
  PrognosisAutumn = 3,
  Actual = 4,
  Playground = 5,
  EstablishedBudget = 7,
  StartingYear = 8
}
